import lrTenantNo from './_src/lrTenantNo.vue'
lrTenantNo.install = function(Vue) {
  Vue.component(lrTenantNo.name, lrTenantNo)
}

export default lrTenantNo